import type { NavLink, SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Blitz Tech Services',
    description: 'Blitz Tech Services designs and builds websites for local businesses and big companies, at prices that make sense.',
    tagline: 'Brilliant websites. Down-to-earth prices.',
    url: getOrigin(),
    ogImage: 'https://blitz-tech-services.cdn.modulify.website/images/share-image.jpg'
}

export const NAV_LINKS: NavLink[] = [
    { href: '/#advert', label: 'Advert' },
    { href: '/#services', label: 'Services' },
    { href: '/#process', label: 'How it works' },
    { href: '/#contact', label: 'Contact' }
]
